/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

setTimeout(function(){
$('.single-option-selector-product').on('change', function() {
  if( this.value != '12oz' )
  {
      console.log(this.value);
$(".rc_block__type__autodeliver").addClass('disbaledcustom');
       $(".rc_block__type__autodeliver").css("display", "none");
       $(".rc_popup__hover").css("display", "none");
    $(".appended").hide();
    $("#rc_radio_options").append("<p class='appended' style='font-size:13px'>Auto subscribe only available for 12oz</p>");
    
$(".rc_radio__autodeliver").attr('disabled','true');
    
  
    
  }
  else
  {
    $(".rc_radio__autodeliver").removeAttr('disabled');
   $(".rc_block__type__autodeliver").css("display", "block");
       $(".rc_popup__hover").css("display", "block");
$(".appended").hide();
    $(".rc_block__type__autodeliver ").removeClass('disbaledcustom');

  }
});
 
},1000)


setTimeout(function(){
$('.single-option-selector-product').on('change', function() {
  if( this.value != '12oz' )
  {
      console.log(this.value);
$(".rc_block__type__autodeliver").addClass('disbaledcustom');
       $(".rc_block__type__autodeliver").css("display", "none");
       $(".rc_popup__hover").css("display", "none");
    $(".appended").hide();
$("#rc_radio_options").append("<p class='appended'  style='font-size:13px'>Auto subscribe only available for 12oz</p>");
    
$(".rc_radio__autodeliver").attr('disabled','true');
    
  
    
  }
  else
  {
    $(".rc_radio__autodeliver").removeAttr('disabled');
   $(".rc_block__type__autodeliver").css("display", "block");
       $(".rc_popup__hover").css("display", "block");
$(".appended").hide();
    $(".rc_block__type__autodeliver ").removeClass('disbaledcustom');

  }
});
 
},2000)


setTimeout(function(){
$('.single-option-selector-product').on('change', function() {
  if( this.value != '12oz' )
  {
      console.log(this.value);
$(".rc_block__type__autodeliver").addClass('disbaledcustom');
     
    $(".rc_block__type__onetime").css("display", "none");   
    $(".rc_block__type__autodeliver").css("display", "none");
       $(".rc_popup__hover").css("display", "none");
    $(".appended").hide();
$("#rc_radio_options").append("<p class='appended'  style='font-size:13px'>Auto subscribe only available for 12oz</p>");
    
$(".rc_radio__autodeliver").attr('disabled','true');
    
  
    
  }
  else
  {
    $(".rc_radio__autodeliver").removeAttr('disabled');
    $(".rc_block__type__onetime").css("display", "block"); 
   $(".rc_block__type__autodeliver").css("display", "block");
       $(".rc_popup__hover").css("display", "block");
$(".appended").hide();
    $(".rc_block__type__autodeliver ").removeClass('disbaledcustom');

  }
});
 
},3000)

